<template>
  <div class="min-h-screen bg-gray-900">
    <!-- Hero Section -->
    <section class="relative py-20 bg-gradient-to-b from-primary-600 to-primary-700 text-white">
      <div class="container mx-auto px-4">
        <div class="max-w-3xl mx-auto text-center">
          <h1 class="text-4xl md:text-5xl font-bold text-white mb-6" data-aos="fade-up">
            {{ $t('notFound.hero.title') }}
          </h1>
          <p class="text-xl text-primary-100" data-aos="fade-up" data-aos-delay="100">
            {{ $t('notFound.hero.subtitle') }}
          </p>
        </div>
      </div>
    </section>

    <!-- Content Section -->
    <section class="py-20">
      <div class="container mx-auto px-4">
        <div class="max-w-2xl mx-auto text-center">
          <div class="mb-12" data-aos="fade-up">
            <div class="text-9xl font-bold text-primary-600 mb-4">404</div>
            <h2 class="text-3xl font-bold text-white mb-4">{{ $t('notFound.content.title') }}</h2>
            <p class="text-gray-600 mb-8">{{ $t('notFound.content.description') }}</p>
          </div>

          <!-- Action Buttons -->
          <div class="flex flex-col sm:flex-row justify-center gap-4" data-aos="fade-up" data-aos-delay="100">
            <router-link 
              to="/" 
              class="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-300"
            >
              {{ $t('notFound.actions.home') }}
            </router-link>
            <button 
              @click="goBack" 
              class="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-300"
            >
              {{ $t('notFound.actions.back') }}
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import AOS from 'aos'
import 'aos/dist/aos.css'

const router = useRouter()
const { t } = useI18n()

const goBack = () => {
  router.go(-1)
}

onMounted(() => {
  AOS.init({
    duration: 800,
    easing: 'ease-in-out',
    once: true
  })
})
</script>

<style scoped>
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--primary-600), var(--primary-700));
}
</style> 